/* eslint-disable */
/* istanbul ignore file */
class EventHandler {
  constructor() {
    this.functionMap = {};
  }

  addCustomEventListener(el, event, func) {
    el[event] = func;
  }

  removeCustomEventListener(el, event) {
    delete el[event];
  }

  addEventListener(el, event, func) {
    if (this.functionMap[event]) {
      this.removeEventListener(el, event);
    }

    this.functionMap[event] = func;
    el.addEventListener(event.split('.')[0], this.functionMap[event]);
  }

  removeEventListener(el, event) {
    el.removeEventListener(event.split('.')[0], this.functionMap[event]);
    delete this.functionMap[event];
  }

  emitCustomEvent(el, event, params) {
    if (el[event] !== undefined)
      el[event](params);
  }
}

export default new EventHandler();
